import React, { ReactNode } from 'react';
import type { NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';

interface PageProps {
  title: string;
  subtitle?: string;
  service?: boolean;
  components: ReactNode[];
  customTitle?: ReactNode;
}

const StaticPageTemplate: NextPage<PageProps> = ({
  title,
  subtitle,
  service,
  components,
  customTitle,
}) => {
  const { t } = useTranslation('services');

  return (
    <div className='flex w-full flex-col items-center bg-white md:bg-gray-100'>
      <div className='z-0 hidden h-60 w-full bg-orange-400 md:absolute md:block' />
      <div className='z-10 my-2 flex w-full flex-col items-center md:my-12'>
        <div className='z-10 flex max-w-[19rem] flex-col space-y-12 rounded-lg bg-white pt-12 md:w-full md:max-w-[41rem] md:px-20 lg:max-w-[60rem] lg:pb-12'>
          {customTitle ? (
            customTitle
          ) : (
            <div>
              <h1
                className='text-start text-2xl font-semibold text-black md:text-3xl '
                data-testid='header-title'
              >
                {title}
              </h1>
              {service && (
                <h1 className='text-md mt-2 text-start text-black md:text-xl'>
                  {t('For Used Beverage Machines')}
                </h1>
              )}
            </div>
          )}
          {subtitle && <div className='text-md'>{t(subtitle)}</div>}
          {components.map((component, index) => (
            <React.Fragment key={index}>{component}</React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StaticPageTemplate;
